const PersonFill = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.188 14.875s-1.063 0-1.063-1.063c0-1.062 1.063-4.25 6.375-4.25 5.313 0 6.375 3.188 6.375 4.25 0 1.063-1.063 1.063-1.063 1.063H3.188ZM8.5 8.5a3.188 3.188 0 1 0 0-6.375 3.188 3.188 0 0 0 0 6.375Z"
        fill="#9C9C9C"
      />
    </svg>
  );
};

export default PersonFill;
